import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {get} from '../Storage';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import KeepAlive from '../KeepAlive';
import CircularProgress from 'material-ui/CircularProgress';
import {Message} from "mgUiKit";


// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetSubAccountsComponent';

var styles = AppSettings.styles;

class SubAccounts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            errorMessage: "",
            data: {},
            showLoading: true,
            opened:false
        }
        this.getBalanceSubAccounts = this.getBalanceSubAccounts.bind(this);
    }


    componentDidMount() {
        //this.getBalanceSubAccounts(false);
    }

    getBalanceSubAccounts(event) {
        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: {},
                showLoading: true,
                opened:false
            });
            return;
        }
        
        this.setState({
            showLoading: true,
            opened:true
        });

        var url = AppSettings['env'].urlUserBoxBalanceSubaccounts;
        axios.get(url)
            .then(({data, status, statusText}) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data.subaccountsBalance,
                        showLoading: showLoading,
                        opened: true
                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: <KeepAlive />,
                        data: {},
                        showLoading: showLoading,
                        opened: true


                    });
                }
            })

            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "Errore durante il caricamento",
                    data: {},
                    showLoading: false,
                    opened: true
                });
            });
    }
    
    renderBalanceSubAccounts(){
        if(this.state.showLoading){
            return <CircularProgress style={styles.loadingIcon}/>;
        } 
        
        if(this.state.error){
            return <Message align="center">{this.state.errorMessage}</Message>;
        }

        if (this.state.data.length > 0) {
            var subaccountsBalance = this.state.data.map(function (subaccount, i) {
            var key = "subaccount" + i;
            return (
                <tr  key={key}>
                    <td>{subaccount.site}</td>
                    <td>{subaccount.balance}<br />{subaccount.withdrawal}</td>
                </tr>
            )
        });

            return (
                <table className="userBoxTable">
                    <tbody>
                    <tr>
                        <th>Sito</th>
                        <th>Saldo/Prelevabile</th>
                    </tr>
                    {subaccountsBalance}
                   
                    </tbody>
                </table>

            )
        }
        return "";

    }

    render() {
        var title = <div style={styles.pointer} onClick={this.getBalanceSubAccounts}>Sottoconti</div>;
        //var subTitle  = <div style={styles.pointer} onClick={this.getBalanceSubAccounts}>Dettagli</div>;

        
        return (  
            <div id="mg-dettaglio-sottoconti">
             
                <Card expanded={this.state.opened} onExpandChange={this.getBalanceSubAccounts} containerStyle={styles.mgCardStyle}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                                subtitleStyle={styles.mgCardSubTitle}
                                title={title}
                                //subtitle={subTitle}
                                subtitle="Dettagli sottoconti"
                                actAsExpander={false}
                                showExpandableButton={true}

                    />
                    <CardText expandable={true} style={styles.cardText}>
                        {this.renderBalanceSubAccounts()}
                    </CardText>
                </Card>
            </div>

        );
    }
}

SubAccounts.displayName = componentName;

// PropTypes validation
SubAccounts.propTypes = {
    
};

// default props
SubAccounts.defaultProps = {
    
};

export default SubAccounts;